<template>
  <b-row v-if="$store.state.user.adresses.length" style="padding-bottom:40px;">
    <b-col style="padding:0px;">
      <b-row align-v="center" style="margin:16px 8px;" v-for="(addr, idxa) in $store.state.user.adresses" v-bind:key="idxa">
        <b-col cols="2">
          <input type="radio" name="address_choice" style="width:20px;height:20px;" :checked="amIselected(addr.id)" @change="selectAddress(addr.id)"/>
        </b-col>
        <b-col cols="10" style="
        font-style: normal;
        font-weight: normal;
        line-height: 17px;
        font-size: 14px;
        letter-spacing: -0.08px;
        color: #525962;
        ">
          {{addr.name}}, {{addr.streetNumber}}<br/>
          {{addr.vicinity}}<br/>
          {{addr.city}} / {{addr.state}}
        </b-col>
      </b-row>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col style="
    margin-top:23px;
    font-style: normal;
    font-weight: normal;
    line-height: 17px;
    font-size: 14px;
    text-align: center;
    color: #525962;
    ">
      Endereço para entrega não encontrado.<br/>
      Clique em cadastrar novo endereço para adicionar
    </b-col>
  </b-row>
</template>

<script>
export default {

  data () {
    return {
      selectedId: 0
    }
  },

  created () {
    if (this.$store.state.user.adresses.length && !this.$store.state.selectedAddressId) {
      this.selectedId = this.$store.state.user.adresses[this.$store.state.user.adresses.length-1].id
      this.selectAddress(this.selectedId)
    } else if (this.$store.state.selectedAddressId) {
      this.selectedId = this.$store.state.selectedAddressId
      this.selectAddress(this.selectedId)
    }
  },

  methods: {
    amIselected (addrId) {
      let amI = (addrId === this.selectedId)
      return amI
    },

    selectAddress (addrId) {
      this.selectedId = addrId
      this.$emit('selectedAddress', addrId)
    }
  }

}
</script>

<style>

</style>
